import {BasePanelPage} from "../../PanelPage";

export class ShopOrderSuccessPanel extends BasePanelPage {
    render() {
        return "OK!";
    }
}